import { useCallback } from 'react'
import { Vector3 } from 'three'
import { modelToUI } from '~/components/DrawingCanvas/util/units'
import { doorProducts, Orientation } from '~/config/doorProducts'
import { useAppSelector } from '~/store/hooks'
import { Door } from '~/store/objects/types'

const DEFAULT_THICKNESS = 24
const MOUNT_SIDE_OFFSET = 1.3
const MOUNT_HEIGHT_OFFSET = 20.3

export const useGetDoorProductPositionOffset = () => {
  const segments = useAppSelector(state => state.objects.present.segments)
  return useCallback(
    ({ width, height, wallSegmentId, rotation, product }: Door, defaultOrientation?: Orientation) => {
      const productOrientation = doorProducts.find(({ name }) => name === product?.name)?.orientations[0]
      const orientation = product?.orientation ?? defaultOrientation ?? productOrientation ?? 'left'
      const halfWidth = modelToUI(width / 2) + MOUNT_SIDE_OFFSET
      const doorThicknessOffset = modelToUI(segments[wallSegmentId]?.thickness ?? DEFAULT_THICKNESS) / 2
      if (orientation === 'center') {
        return new Vector3(0, -doorThicknessOffset)
          .applyAxisAngle(new Vector3(0, 0, 1), rotation._z)
          .setZ(modelToUI(height))
      }
      return new Vector3(halfWidth * (orientation === 'left' ? -1 : 1), -doorThicknessOffset)
        .normalize()
        .multiplyScalar(halfWidth)
        .applyAxisAngle(new Vector3(0, 0, 1), rotation._z)
        .setZ(modelToUI(height - MOUNT_HEIGHT_OFFSET))
    },
    [segments]
  )
}
